import type { SxProps, Theme } from '@mui/material/styles'
import { palettePrimaryMain as PRIMARY } from '@/theme/designTokens'

export const CONFIRMATION_MODAL_WIDTH = 448

export const confirmationBackdropSx = {
  bgcolor: 'rgba(4, 24, 63, 0.55)',
} as const

export const confirmationPaperSx = {
  width: '100%',
  maxWidth: CONFIRMATION_MODAL_WIDTH,
  borderRadius: '10px',
  boxShadow:
    '0px 20px 12.5px rgba(0, 0, 0, 0.1), 0px 8px 5px rgba(0, 0, 0, 0.1)',
  bgcolor: '#ffffff',
  m: 2,
  overflow: 'hidden',
} as const

export const confirmationHeadlineSx = {
  fontFamily: '"Inter", sans-serif',
  fontWeight: 700,
  fontSize: '20px',
  lineHeight: '28px',
  letterSpacing: '-0.4492px',
  color: '#23262f',
  textAlign: 'center',
  width: '100%',
} as const

export const confirmationHeadlineLargeSx = {
  ...confirmationHeadlineSx,
  fontSize: '32px',
  lineHeight: '40px',
  letterSpacing: '0.4063px',
} as const

export const confirmationBodySx = {
  fontFamily: '"Inter", sans-serif',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '22.75px',
  letterSpacing: '-0.1504px',
  color: '#4a5565',
  display: 'block',
} as const

export const confirmationBodyCompactSx = {
  ...confirmationBodySx,
  lineHeight: '20px',
  color: '#061e32',
} as const

export const confirmationSecondaryButtonSx: SxProps<Theme> = {
  height: 40,
  minWidth: 100,
  px: 2,
  borderRadius: '12px',
  borderWidth: '1.5px',
  borderColor: '#e5e7eb',
  color: '#6b6b6b',
  fontFamily: '"Inter", sans-serif',
  fontWeight: 600,
  fontSize: '14px',
  lineHeight: '16px',
  textTransform: 'none',
  boxShadow: 'none',
  '&:hover': {
    borderWidth: '1.5px',
    borderColor: '#d1d5db',
    bgcolor: '#fafafa',
    boxShadow: 'none',
  },
}

export const confirmationPrimaryButtonSx: SxProps<Theme> = {
  height: 40,
  minWidth: 100,
  px: 2,
  borderRadius: '12px',
  bgcolor: PRIMARY,
  color: '#ffffff',
  fontFamily: '"Inter", sans-serif',
  fontWeight: 600,
  fontSize: '14px',
  lineHeight: '16px',
  textTransform: 'none',
  boxShadow: 'none',
  '&:hover': { bgcolor: '#0076b0', boxShadow: 'none' },
}

export const confirmationDangerButtonSx: SxProps<Theme> = {
  ...confirmationPrimaryButtonSx,
  bgcolor: '#ff5959',
  '&:hover': { bgcolor: '#e04848', boxShadow: 'none' },
}

/** Figma 6103:11324 — pause / caution confirm (amber). */
export const confirmationCautionButtonSx: SxProps<Theme> = {
  ...confirmationPrimaryButtonSx,
  bgcolor: '#f59e0b',
  '&:hover': { bgcolor: '#d97706', boxShadow: 'none' },
}

/** BFP-616 — reactivate confirm (solid green per user story). */
export const confirmationSuccessButtonSx: SxProps<Theme> = {
  ...confirmationPrimaryButtonSx,
  bgcolor: '#22c55e',
  '&:hover': { bgcolor: '#16a34a', boxShadow: 'none' },
}

export const confirmationPrimaryFullWidthButtonSx: SxProps<Theme> = {
  ...confirmationPrimaryButtonSx,
  height: 52,
  borderRadius: '8px',
  fontSize: '16px',
  lineHeight: '24px',
  letterSpacing: '-0.3125px',
  fontWeight: 500,
  maxWidth: 400,
  width: '100%',
}
